export default __webpack_public_path__ + "static/media/pom_line.bd4fc5c1.png";